import {
  afterNextRender,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { BaseComponent } from '../../shared/components/base/base.component';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReviewComponent, ReviewConfig } from '../review/review.component';
import { register } from 'swiper/element';



@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
  imports: [
    TranslateModule,
    NgClass,
    ReviewComponent
  ],
    styleUrls: ['./../website-grid.scss', './reviews.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReviewsComponent extends BaseComponent implements OnInit {
  @Input() isShowCharacter: boolean = false;
  @ViewChild('swiperContainer', { static: false }) swiperContainer?: ElementRef;

  platformId = inject(PLATFORM_ID);

  isBrowser = isPlatformBrowser(this.platformId);

  reviews: ReviewConfig[] = [
    {
      imageSrc: '/assets/img/website/reviews/axel.png',
      imageAlt: 'WEBSITE.REVIEWS.LIST.PKA.AUTHOR',
      text: 'WEBSITE.REVIEWS.LIST.PKA.TEXT',
      personName: 'WEBSITE.REVIEWS.LIST.PKA.AUTHOR',
      personPosition: 'WEBSITE.REVIEWS.LIST.PKA.POSITION',
      imageWidth: 120,
      imageHeight: 120,
      logo: {
        src: '/assets/img/website/reviews/pka.png',
        alt: 'PKA Logo',
        width: 108,
        height: 40
      }
    },
    {
      imageSrc: '/assets/img/website/reviews/trine.png',
      imageAlt: 'WEBSITE.REVIEWS.LIST.FURSETGRUPPEN.AUTHOR',
      text: 'WEBSITE.REVIEWS.LIST.FURSETGRUPPEN.TEXT',
      personName: 'WEBSITE.REVIEWS.LIST.FURSETGRUPPEN.AUTHOR',
      personPosition: 'WEBSITE.REVIEWS.LIST.FURSETGRUPPEN.POSITION',
      imageWidth: 120,
      imageHeight: 120,
      logo: {
        src: 'assets/img/website/group-structure/fursetgruppen.png',
        alt: 'Fursetgruppen Logo',
        width: 64,
        height: 40
      }
    },
    {
      imageSrc: '/assets/img/website/reviews/bjorn.png',
      imageAlt: 'WEBSITE.REVIEWS.LIST.SLETTVOLL.AUTHOR',
      text: 'WEBSITE.REVIEWS.LIST.SLETTVOLL.TEXT',
      personName: 'WEBSITE.REVIEWS.LIST.SLETTVOLL.AUTHOR',
      personPosition: 'WEBSITE.REVIEWS.LIST.SLETTVOLL.POSITION',
      imageWidth: 120,
      imageHeight: 120,
      logo: {
        src: '/assets/img/website/retail/slv.png',
        alt: 'SLV logo',
        width: 30,
        height: 40
      }
    }
  ];

  constructor() {
    super();

    afterNextRender(() => {
      this.initializeSwiper();
    });
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      try {
        register();
      } catch (e) {
        console.error('Error in registering swiper.js on career page >>> ', e);
      }
    }
  }

  private initializeSwiper(): void {
    const swiperEl = this.swiperContainer?.nativeElement;

    const swiperParams = {
      spaceBetween: 24,
      slidesPerView: 1.2,
      loop: true,
      autoHeight: false,
      grabCursor: true,
      breakpoints: {
        961: {
          spaceBetween: 40,
          grabCursor: false,
          slidesPerView: 1.7,
        }
      }
    };

    if (swiperEl) {
      Object.assign(swiperEl, swiperParams);
      swiperEl.initialize();
    }
  }

  goNext(): void {
    const swiperEl = this.swiperContainer?.nativeElement;

    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.slideNext();
    }
  }

  goPrev(): void {
    const swiperEl = this.swiperContainer?.nativeElement;

    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.slidePrev();
    }
  }
}
